<template>
    <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card>
            <v-toolbar
                color="secondary"
                flat
            >
                <v-toolbar-title class="text-h6 white--text">
                    {{ $t("actionListmod.customRecurrence") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar> 
			<v-divider></v-divider>
			<v-card-text>
			    <div class="inline mt-5">
				    <v-row no-gutters>
                        <v-col cols="" class="mt-2">
                            <p>{{ $t("actionListmod.repeatEvery") }}</p>
                        </v-col>
                        <v-col cols="">
                            <v-text-field
                                type="number"
                                v-model="customObj.repeatEveryValue"
                                outlined
                                dense
                                min="1"
                                :rules="repeatErrors.repeatEveryValue"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="" class="ml-2">
                            <v-select
                                type="number"
                                v-model="customObj.repeatEveryUnit"
                                :items="items"
                                item-text="text"
                                outlined
                                dense
                            ></v-select>
                        </v-col>
				    </v-row>
                    <div class="mb-1">Select Day</div>
				    <v-row no-gutters>
                        <v-col v-for="(week, index) in weekDays" :key="index">
                            <v-avatar size="30" color="primaryLignt"  event-color="secondary">
                                <v-btn
                                    text
                                    icon
                                    @click="setweekDay(week)"
                                    :class="{ activeClass: week.selected }"
                                    class="primary--text"
                                    ><span > {{ week.text }}</span>
                                </v-btn>
                            </v-avatar>
                        </v-col>
				    </v-row>
				    <div class="mt-5">
				        <v-radio-group 
                            label="Ends" 
                            v-model="customObj.isNeverEnding"
                        >
                            <v-radio
                                name="repeatEnds"
                                label="Never"
                                value="never"
                            >
					        </v-radio>

					        <v-layout row class="mt-1">
					            <v-col cols>
                                    <v-radio
                                        name="repeatEnds"
                                        class="mt-2"
                                        label="On"
                                        value="on"
                                    >
                                    </v-radio>
					            </v-col>
					            <v-col cols>
                                    <v-menu
                                        v-model="drugMfgmenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :disabled="customObj.isNeverEnding!='on'"
                                                v-model="customObj.endingOn"
                                                append-icon="mdi-calendar"
                                                outlined
                                                dense
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                :error-messages="endOnError"
                                            >
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                            no-title
                                            v-model="customObj.endingOn"
                                            @input="drugMfgmenu = false"
                                            :min="new Date().toISOString().substr(0, 10)"
                                        ></v-date-picker>
						            </v-menu>
					            </v-col>
					        </v-layout>
					        <v-layout row class="mt-n5">
                                <v-col cols>
                                    <v-radio
                                    name="repeatEnds"
                                    class="mt-2"
                                    label="After"
                                    value="after"
                                    ></v-radio>
                                </v-col>
                                <v-col cols>
                                    <v-text-field
                                        outlined
                                        dense
                                        type="number"
                                        :disabled="customObj.isNeverEnding !== 'after'"
                                        v-model="customObj.endingAfterOccurenceCount"
                                        :error-messages="endAfterError"
                                        min="1"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols>
                                    <v-text-field
                                    outlined
                                    dense
                                    :disabled="true"
                                    value="Occurrences"
                                    ></v-text-field>
                                </v-col>
					        </v-layout>
				        </v-radio-group>
                    </div>
			    </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" depressed @click="saveRepeatSettings">Confirm</v-btn>
                </v-card-actions>
			</v-card-text>
		</v-card>
    </v-dialog>
</template>

<script>
export default {
    mounted() {
        if(this.repeatData){
            console.log('rrr', this.repeatData)
            const newWeek = []
            this.weekDays.forEach((d) => {
                d.selected = this.repeatData[d.value]
                newWeek.push(d)
                if (d.selected) {
                    this.repeatWeekDays.push(d.value);
                }
            })
            this.weekDays = [...newWeek]
                this.customObj.repeatEveryValue = this.repeatData.repeatEveryValue
                this.customObj.repeatEveryUnit = this.repeatData.repeatEveryUnit
                this.customObj.endingOn = this.repeatData.endingOn
                this.customObj.isNeverEnding = this.repeatData.isNeverEnding
                this.customObj.endingAfterOccurenceCount = this.repeatData.endingAfterOccurenceCount

        }
    },
    props: {
        dialog: {
            require: true,
            type: Boolean
        },
        repeatData: {
            type: Object
        }
    },

    data() {
        return {
            drugMfgmenu: false,
            repeatWeekDays: [],
            active: false,
            customObj: {
                repeatEveryValue: 1,
                repeatEveryUnit: 'Day',
                endingOn: '',
                isNeverEnding: 'never',
                endingAfterOccurenceCount: 0
            },
            endOnError: '',
            endAfterError: '',
            items: ["Day", "Week","Month","Year"],
            weekDays: [
				{
					text: "S",
					value: "sunday",
					selected: false,
				},
				{
					text: "M",
					value: "monday",
					selected: false,
				},
				{
					text: "T",
					value: "tuesday",
					selected: false,
				},
				{
					text: "W",
					value: "wednesday",
					selected: false,
				},
				{
					text: "T",
					value: "thursday",
					selected: false,
				},
				{
					text: "F",
					value: "friday",
					selected: false,
				},
				{
					text: "S",
					value: "saturday",
					selected: false,
				},
			],
            repeatErrors: {
                repeatEveryValue: [
                    (v) => !!v || 'Repeat value is required.',
                    (v) => (v >= 1) || 'Can not be less then 1..',
                ],
            }
        }
    },
    watch: {
        'customObj.repeatEveryValue': {
            handler(e) {
                if(e <= 1){
                    this.customObj.repeatEveryValue = 1
                }
            },
            deep: true
        },
        'customObj.isNeverEnding': {
            handler(e) {
                this.endAfterError = this.endOnError= ''
                if(e == 'never'){
                    this.customObj.endingAfterOccurenceCount = 0
                    this.customObj.endingOn = ''
                }else if(e == 'on') {
                    this.customObj.endingAfterOccurenceCount = 0
                }else if(e == 'after') {
                    this.customObj.endingOn = ''
                }
            },
            deep: true
        }
    },
    methods: {
        closeModal() {
            this.$emit("modal-closed");
        },
        setweekDay(week) {
            week.selected = !week.selected;

            if (week.selected) {
                this.repeatWeekDays.push(week.value);
            } else {
                let index = this.repeatWeekDays.indexOf(week.value);
                this.repeatWeekDays.splice(index, 1);
            }
        },
        saveRepeatSettings() {
            this.endAfterError = this.endOnError= ''
            if(this.customObj.isNeverEnding == 'on' && this.customObj.endingOn == "") {
                this.endOnError = "End date is required"
                return
            }
            if(this.customObj.isNeverEnding == 'after' && !this.customObj.endingAfterOccurenceCount) {
                this.endAfterError = "Occurrences are required"
                return
            }
            if(this.customObj.isNeverEnding == 'never') {
                this.customObj.isNeverEnding = true;
            }else{
                this.customObj.isNeverEnding = false;
            }

            this.weekDays.forEach((d) => {
                this.customObj[d.value] = d.selected
            })
            this.customObj.repeatEveryValue = parseInt(this.customObj.repeatEveryValue)
            this.customObj.endingAfterOccurenceCount = parseInt(this.customObj.endingAfterOccurenceCount)
            this.$emit("repeat-settings-saved", this.customObj);
        }
    }
}
</script>

<style scoped>
.activeClass {
  background-color: #00BD73 !important;
  color: white !important;
}


</style>